import { ApiDocs } from '@/api-docs';

function ConfigDefinition() {
  return (
    <ApiDocs apiDescriptionUrl="/doc-assets/swagger/api_v1_config_swagger_DOCUMENTATION_ONLY.json" />
  );
}

export default ConfigDefinition;
